module.exports = __webpack_public_path__ + "06_mole.fbc19e00.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer3/06_mole.png
// module id = oE/M
// module chunks = 0